var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasUrl && _vm.name !== 'merch')?_c('a',{attrs:{"href":_vm.url,"target":"_blank","rel":"noopener noreferrer","aria-label":'Vist our ' + _vm.name + '!'}},[_c('font-awesome-icon',{attrs:{"icon":['fab', _vm.name],"size":"2x"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }